<div class="page diagnostics">
  <div class="adminpanel">
    <div class="navblock">
      <app-group-filter #groupFilter [groups]="groups"
        [canEditGroup]="canEditGroup.bind(this)"
        [canDeleteGroup]="canDeleteGroup.bind(this)"
        (onAddGroup)="openGroupAccessDialog()"
        (onEditGroup)="openGroupAccessDialog($event)"
        (onDeleteGroup)="deleteGroup($event)"
        (onSelectGroup)="selectGroup($event)">
      </app-group-filter>
      <app-objects-filter (onSearch)="onExtendedTermChange($event)"></app-objects-filter>
      <div class="company-filter">
        <p-multiselect [options]="companies" [ngModel]="selectedCompanyIds"
          (ngModelChange)="onCompanyFilterChange($event)"
          optionLabel="Name" optionValue="Id" [filter]="true"
          filterBy="Name" [showClear]="true" [appendTo]="'body'"
          styleClass="objects-company-multiselect"
          panelStyleClass="objects-company-multiselect-panel"
          [placeholder]="'All companies' | translate">
        </p-multiselect>
      </div>
      <div>
        <button class="btn_img_large btn_show_checked_off" title="{{'Hide objects status' | translate}}" *ngIf="ShowStatus" (click)="setShowStatus(false)"></button>
        <button class="btn_img_large btn_show_checked" title="{{'Hide objects status' | translate}}" *ngIf="!ShowStatus" (click)="setShowStatus(true)"></button>
      </div>
      <div></div>
      <button id="setintervalbtn" class="btn_blue" (click)="refresh()">{{'Apply'|translate }}</button>
    </div>
    <div class="tablewrap resizetable">
      <div class="table">
        <table fixedcols="[]" id="exporttable" [ngClass]="{'largeTable': ShowStatus}">
          <tr>
            <th>
                <switch-all-checkbox [items]="objects" />
            </th>
            <th class="object_column">{{'Company'|translate}}</th>
            <th class="object_column">{{'Object'|translate}}</th>
            <th class="object_column">{{'IMEI'|translate}}</th>
            <th class="object_column">{{'Phone №'|translate}}</th>
            <th class="object_column">{{'Model'|translate}}</th>
            <th class="small_column">{{'Status'|translate}}</th>
            <th class="datetime_column">{{'Time'|translate}}</th>
            <th class="small_column" *ngIf="ShowStatus">{{'Power'|translate}}</th>
            <th class="small_column"*ngIf="ShowStatus">{{'Fuel'|translate}}</th>
            <th class="mileage_column">{{'Odometer'|translate}}</th>
            <th class="time_column"*ngIf="ShowStatus">{{'Engine time'|translate}}</th>
            <th class="small_column">{{'State'|translate}}</th>
            <th>{{'Address'|translate}}</th>
            <th></th>
          </tr>

          <tr *ngFor="let obj of objects | pagesfilter: pageInfoFilter; trackBy: trackById">
            <td>
              <input type="checkbox" [(ngModel)]="obj.IsChecked"/>
            </td>
            <td>{{obj.CompanyName}}</td>
            <td>{{obj.Name}}</td>
            <td>{{obj.IMEI}}</td>
            <td>{{obj.Phone}}{{obj.Phone1 ? ', ' + obj.Phone1 : ''}}</td>
            <td>{{obj.DeviceModel | translate}}</td>
            <td [ngClass]="{'alarm': obj.Status!=1}">{{getStatus(obj.Status) | translate}}</td>
            <td [ngClass]="{'alarm': obj.Time < now - day * 7, 'warning': obj.Time < now - day}">{{obj.Time | datetime:'%0D.%0M.%0Y %0h:%0m:%0s'}}</td>
            <td *ngIf="ShowStatus" [ngClass]="{'warning': obj.LowPower || (obj.LastPower.indexOf('--') == 0)}">{{obj.LastPower}}</td>
            <td *ngIf="ShowStatus" [ngClass]="{'warning': obj.LastFuel.indexOf('--') == 0}">{{obj.LastFuel}}</td>
            <td>{{obj.Odometer | localizeKMeters}} {{'km'|localizeUnits}}</td>
            <td *ngIf="ShowStatus">{{obj.EngineTime}} {{'h' | translate}}</td>
            <td>
              <button class="btn_img btn_online" title="{{'Online' | translate}}" *ngIf="obj.Online"></button>
              <button class="btn_img btn_offline" title="{{'Offline' | translate}}" *ngIf="!obj.Online"></button>
              <button class="btn_img btn_not_fixed" title="{{'Position is not fixed' | translate}}" *ngIf="!obj.Sat && !obj.Accuracy"></button>
            </td>
            <td class="address">{{obj.Address}}</td>
            <td>
              <button  *ngIf="canAccessComponent(AccessRights.EDIT)" class="btn_img btn_edit" (click)="openEditModal(obj)" title="{{'Edit'|translate}}"></button>
              <button *ngIf="canAccessComponent(AccessRights.EDIT)" class="btn_img btn_trush" (click)="deleteDevice(obj)" title="{{'Delete'|translate}}"></button>
            </td>
          </tr>
          <tr>
            <th colspan="4">{{'Total'|translate}}: {{objects.length}}</th>
            <th colspan="4">{{'Blocked'|translate}}: {{blockedCount}}</th>
            <th [attr.colspan]="ShowStatus ? 4 : 3">{{'Irrelevant data'|translate}}: {{oldTimestampCount}}</th>
            <th class="address_all" [attr.colspan]="ShowStatus ? 3 : 1"></th>
          </tr>
        </table>
      </div>
    </div>
    <app-pagination [viewmode]="'print excel pages'" [printElementID]="'exporttable'" [items]="objects" [initialItemsPerPage]="50" (onPageChange)="onPageChange($event)"></app-pagination>
    <app-object-group-access [objects]="objects" (groupsChanged)="onGroupsChanged()"></app-object-group-access>
  </div>
</div>
<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
